import promptDialogs from 'i18n/en/common/prompt_dialog'

export default {
  ...promptDialogs
}
